{
  "nl": {
    "milestone_unit": {
      "actions": {
        "change_milestone": "Mijlpaal wijzigen",
        "reset_columns": "Kolommen herstellen"
      },
      "labels": {
        "columns": "Kolommen",
        "milestone": "Selecteer een nieuwe mijlpaal",
        "no_results": "Geen eenheden gevonden"
      }
    }
  }
}